<template>
  <div class="footer">
    <div class="top">
      <div class="container">
        <div class="left">
          <h3>版权所有</h3>
          <p>中国旅行社协会<span style="padding: 0 10px;"></span>研学旅行指导师测评项目办公室</p>
        </div>
        <div class="right">
          <div>
            <img src="../../assets/img/u906.jpg" alt="">
          </div>
          <p>【关注研学招聘服务号，随时查看新简历】</p>

        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="container">
        Copyright © 2022 研学招聘 <a href="
https://beian.miit.gov.cn" target="_blank">京ICP备2020033869号-1</a>    |  <a href="/new">新闻资讯</a>  |  <a href="/shenming" target="_blank">法律声明</a>  |  <a href="/yinsi" target="_blank">隐私政策</a> |  <a href="/help" target="_blank">帮助中心</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerDiv"
}
</script>

<style scoped lang="scss">
.footer {
  height: 302px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  .top{
    height: 244px;
    .container{
      display: flex;
      justify-content: space-between;
      .left{
        width: 590px;
        padding: 40px 0;
        h3{
          font-size: 20px;
          font-weight: 500;
          margin: 15px 0;
        }
        p{
          font-size: 16px;
          line-height: 38px;
          color: #666666;
        }
      }
      .right{
        width: 300px;
        padding-top: 35px;
        div{
          width: 110px;
          height: 110px;
          border: 1px solid #eee;
          padding: 3px;
          margin: 0 auto;
          img{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        p{
          text-align: center;
          font-size: 14px;
          line-height: 38px;
          color: #666666;
        }
      }
    }
  }
  .bottom{
    height: 58px;
    background: #636363;
    .container{
      line-height: 58px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      span{
        padding: 0 10px;
        cursor: pointer;
      }
      a{
        color: #fff;
      }
    }
  }
}
</style>
